<button type="button" [attr.type]="_buttonAction === 1 ? 'button' : 'submit'" [attr.disabled]="_disabled ? 'disabled' : null" class="btn btn-primary btn-lg">
    <ng-content></ng-content>
</button>
